import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { createColumnHelper } from '@tanstack/react-table'

import { Badge } from '@/components/ui/badge'
import { PageCard, PageLayout } from '@/components/ui/page'
import {
	CellContent,
	CellText,
	CellTextDate,
	DataTable,
	useDataTable,
} from '@/components/ui/table/data-table'

import { itemCategoryList } from '@/features/item/api'
import type { IItemCategory } from '@/features/item/type'

export const Route = createFileRoute('/_app/inventory/category/')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/master', 'Master '],
					['/inventory/master/category', 'Category'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header
					title="Daftar Master Item"
					actions={
						<PageCard.HeaderAction asChild>
							<Link from={Route.fullPath} to="/inventory/category/create">
								Tambah Kategori
							</Link>
						</PageCard.HeaderAction>
					}
				/>
				<CategoryTable />
			</PageCard.Root>
		</PageLayout>
	)
}

function CategoryTable() {
	const navigate = Route.useNavigate()
	const { data, isLoading } = useQuery(itemCategoryList.qry({}))
	const columns = useMemo(getColumns, [])
	const { table } = useDataTable({
		columns,
		data: data?.categories ?? [],
		getRowId: (row) => row.id,
	})

	return (
		<DataTable
			table={table}
			columns={columns}
			isLoading={isLoading}
			onRowClick={(row) => {
				navigate({
					to: '/inventory/category/$id',
					params: { id: row.original.id },
				})
			}}
		/>
	)
}

const ch = createColumnHelper<IItemCategory>()

function getColumns() {
	return [
		ch.accessor('name', {
			header: 'Nama Kategori',
			cell: ({ row }) => <CellText text={row.original.name} />,
		}),
		ch.accessor('isActive', {
			header: 'Status',
			cell: ({ row }) => {
				const { isActive } = row.original
				return (
					<CellContent>
						<Badge color={isActive ? 'green' : 'red'} size="small">
							{isActive ? 'Aktif' : 'Tidak aktif'}
						</Badge>
					</CellContent>
				)
			},
		}),
		ch.accessor('createdAt', {
			header: 'Created At',
			cell: ({ row }) => <CellTextDate date={row.original.createdAt} />,
		}),
		ch.accessor('updatedAt', {
			header: 'Updated At',
			cell: ({ row }) => <CellTextDate date={row.original.updatedAt} />,
		}),
	]
}
